export enum FeeWaiverStatusEnum {
    ACTIVE = 1,
    UPCOMING,
    EXPIRED,
    NEW,
}
